import { requestOpenRouter } from '../utils/openRouterClient';
import {
  buildCoachSystemPrompt,
  buildCoachUserPrompt,
  buildRecommendationPrompt,
} from '../utils/promptTemplates';

function parseJSONSafe(text) {
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

export async function getCoachReply(context, question) {
  const messages = [
    { role: 'system', content: buildCoachSystemPrompt() },
    { role: 'user', content: buildCoachUserPrompt(context, question) },
  ];

  return requestOpenRouter(messages, { temperature: 0.5, maxTokens: 420 });
}

export async function getActionRecommendations(context) {
  const messages = [
    { role: 'system', content: 'You generate strict JSON recommendations.' },
    { role: 'user', content: buildRecommendationPrompt(context) },
  ];

  const raw = await requestOpenRouter(messages, { temperature: 0.3, maxTokens: 320 });
  const parsed = parseJSONSafe(raw);

  if (!parsed?.recommendations || !Array.isArray(parsed.recommendations)) {
    return [];
  }

  return parsed.recommendations;
}
